export { ViewBaseComponent } from './view-base.component';
export { ViewDetailComponent } from './view-detail.component';
export { ViewFormComponent } from './view-form.component';
export { defaultDetailImports, defaultListImports } from './default-imports';